export class FailedToCreateMappingError {

};
